var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex align-center background-auth",
      staticStyle: { height: "100vh" },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "mx-auto text-left pa-8 bgPanel",
          attrs: { width: 480, flat: "", align: "center", justify: "center" },
        },
        [
          _c("v-col", { staticClass: "text-center pa-0 mt-2 mb-6" }, [
            _c("img", {
              attrs: {
                src: require(`@/assets/appBrand--ax-full.svg`),
                width: "211",
              },
            }),
            _c(
              "span",
              {
                staticClass:
                  "mt-2 d-block subtitle-1 grey-500--text font-weight-bold",
              },
              [_vm._v("Aceptar invitación")]
            ),
          ]),
          _c(
            "v-form",
            [
              !this.$route.query.invitation
                ? _c(
                    "v-col",
                    { staticClass: "pa-0 mt-5" },
                    [
                      _c("span", { staticClass: "body-1 grey-500--text" }, [
                        _vm._v("Email"),
                      ]),
                      _c("v-text-field", {
                        attrs: {
                          error: _vm.$v.user.email.$error,
                          outlined: "",
                          "hide-details": "",
                          required: "",
                          "single-line": "",
                          dense: "",
                          maxlength: "254",
                        },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.signUp.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.user.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.user, "email", $$v)
                          },
                          expression: "user.email",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                {
                  class: `${
                    _vm.$v.user.password1.minLength ? "my-5" : "mt-5 mb-3"
                  } pa-0`,
                },
                [
                  _c("span", { staticClass: "body-1 grey-500--text" }, [
                    _vm._v("Contraseña"),
                  ]),
                  _c("v-text-field", {
                    staticClass: "icon-field",
                    attrs: {
                      error: _vm.$v.user.password1.$error,
                      "append-icon": _vm.show1 ? "mdi-eye" : "mdi-eye-off",
                      type: _vm.show1 ? "user.password1" : "password",
                      outlined: "",
                      "hide-details": _vm.$v.user.password1.minLength,
                      "persistent-hint": "",
                      required: "",
                      "single-line": "",
                      dense: "",
                      maxlength: "20",
                      autocomplete: "new-password",
                      hint: "Escribe al menos 8 caracteres.",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.signUp.apply(null, arguments)
                      },
                      "click:append": function ($event) {
                        _vm.show1 = !_vm.show1
                      },
                    },
                    model: {
                      value: _vm.user.password1,
                      callback: function ($$v) {
                        _vm.$set(_vm.user, "password1", $$v)
                      },
                      expression: "user.password1",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pa-0 my-5" },
                [
                  _c("span", { staticClass: "body-1 grey-500--text" }, [
                    _vm._v("Confirmar contraseña"),
                  ]),
                  _c("v-text-field", {
                    staticClass: "icon-field",
                    attrs: {
                      error: _vm.$v.user.password2.$error,
                      "append-icon": _vm.show ? "mdi-eye" : "mdi-eye-off",
                      type: _vm.show ? "user.password2" : "password",
                      outlined: "",
                      "hide-details": _vm.$v.user.password2.sameAsPassword,
                      "persistent-hint": "",
                      required: "",
                      "single-line": "",
                      dense: "",
                      maxlength: "20",
                      autocomplete: "new-password",
                      hint: "La contraseña debe ser igual.",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.signUp.apply(null, arguments)
                      },
                      "click:append": function ($event) {
                        _vm.show = !_vm.show
                      },
                    },
                    model: {
                      value: _vm.user.password2,
                      callback: function ($$v) {
                        _vm.$set(_vm.user, "password2", $$v)
                      },
                      expression: "user.password2",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "py-0 px-1 body-2 grey-500--text pr-6",
                  attrs: { cols: "9" },
                },
                [
                  _vm._v(
                    " Al " +
                      _vm._s(
                        this.$route.query.invitation
                          ? " iniciar sesión"
                          : "crear la cuenta"
                      ) +
                      " aceptas nuestros términos de uso y política de privacidad. "
                  ),
                ]
              ),
              _vm.error
                ? _c(
                    "v-col",
                    { staticClass: "py-0 px-2 text-center" },
                    [
                      _c(
                        "v-alert",
                        {
                          staticClass: "body-2 red--text pa-0",
                          attrs: {
                            border: "left",
                            "colored-border": "",
                            color: "white",
                            dense: "",
                          },
                        },
                        [_vm._v(_vm._s(_vm.error))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                { staticClass: "mb-6 mt-13 pa-0" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.signUpLoader,
                        "retain-focus-on-click": "",
                        color: "grey-900",
                        height: "40",
                        dark: "",
                        block: "",
                        ripple: false,
                      },
                      on: { click: _vm.signUp },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$route.query.invitation ? "Unirse" : "Comenzar"
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-col",
            { staticClass: "text-center pa-0 mt-6 mb-n2" },
            [
              _c(
                "span",
                { staticClass: "d-block body-2 grey-500--text mt-5" },
                [_vm._v("¿Ya tienes una cuenta Factura X? ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "body-1 mt-1",
                  attrs: {
                    to: { name: "AuthSignIn", params: _vm.$route.params },
                    text: "",
                    color: "grey-900",
                    small: "",
                    ripple: false,
                  },
                },
                [_vm._v("Inicia sesión")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }